import React from "react";
import { Route, Switch, useHistory } from "react-router";
import Images from "../../../assets/Images/0_ExportImages";
import SearchHash from "../../Common/SearchHash/SearchHash";
import HomeTransaction from "../../HomeTransaction/HomeTransaction";
import Transaction from "../../Transaction/Transaction";
import TransactionPage from "../../TransactionPage/TransactionPage";
import "./homepage.style.scss";
export default function Homepage() {
  let token = localStorage.getItem("userToken");
  const history = useHistory();
  const [hideHeader, setHideHeader] = React.useState(false);
  const handleClick = () => {
    if (!token) {
      history.push("/login");
    } else {
      localStorage.clear();
      history.push("/home");
    }
  };
  return (
    <div
      className={`home-page-main-wrapper ${
        hideHeader ? "hide-header-home" : ""
      }`}
    >
      <div className="home-page-header">
        <div className="h-p-header-left">
          <img onClick={() => history.push("/home")} src={Images.ethScan} />
        </div>
        <div className="h-p-header-right">
          {/* <div className="header-right-upper">
            <SearchHash />
          </div> */}
          {token &&<button onClick={()=> history.push("/home/transaction")}>My Transactions</button>}
          <button onClick={() => handleClick()} className="sign-in-button">
            <img
              src={
                !token
                  ? "https://img.icons8.com/pastel-glyph/64/000000/user-male--v1.png"
                  : "https://img.icons8.com/metro/26/000000/lock-2.png"
              }
            />
            {!token ? "Sign in" : "Log out"}
          </button>
        </div>
      </div>
      <div className="home-page-body">
        <Switch>
          <Route
            path="/home/transaction/:hash"
            render={() => (
              <TransactionPage setHideHeader={() => setHideHeader(false)} />
            )}
          />
          <Route
            path="/home/transaction"
            render={() => (
              <Transaction setHideHeader={() => setHideHeader(false)} />
            )}
          />
          <Route
            path="/home"
            render={() => (
              <HomeTransaction setHideHeader={() => setHideHeader(true)} />
            )}
          />
        </Switch>
      </div>
      <footer className="home-page-footer"></footer>
    </div>
  );
}
